import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Header } from "../components/Header";
import { Sidebar } from "../components/Sidebar";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import styles from "./Layout.module.css";
import axios from "axios";
import { getStatusParam } from "../../utils";
import { useStoreContext } from "../../hooks/useStoreContext";
import { actions } from "../../store";
import axiosClient from "../../services/axiosClient";

const cx = classNames.bind(styles);
export const StateContext = React.createContext();
const Layout = ({ children }) => {
   const [collapsed, setCollapsed] = useState(false)
  const [isSmall, setIsSmall] = React.useState(false);
  const [isActiveFunc, setIsActiveFunc] = React.useState(false);
  const navigate = useNavigate();
  const [dataStore, dispatch] = useStoreContext();

  useEffect(() => {
    const param = getStatusParam(["token", "cameraCode", "cameraName", "status"]);
    if (param?.token) {
      localStorage?.setItem('token', param?.token);
      sessionStorage?.setItem('token', param?.token);
      const url = new URL(window.location.href);
      if (param?.cameraCode) {
        navigate(url?.pathname + `?cameraCode=${param?.cameraCode}` + `&cameraName=${param?.cameraName}` + `&status=${param?.status}`);
      } else {
        navigate(url?.pathname);
      }
      window.location.reload();
    }
    if (param?.cameraCode && param?.cameraName && param?.status) {
      const dataAdd = {
        type: "cam",
        add: true,
        data: [
          {
            name: param?.cameraName,
            code: param?.cameraCode,
            status: false,
            camStatusActive:
              param?.status === "On"
                ? 1
                : param?.status === "Off"
                  ? 4
                  : 3,
          },
        ],
      };
      dispatch(actions.getListCodeCamera(dataAdd));
    }
  }, [])

  const navigateLogin = () => {
    navigate("/login");
  };

  useEffect(() => {
    const param = getStatusParam(["token"]);
    const refreshToken = localStorage.getItem("refresh");
    const token = localStorage.getItem("token");
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("refresh", refreshToken);
    // Check url nếu url có token thì thôi lấy token đó rồi. còn nếu ko có token thì về login
    if (!token && !refreshToken && !param?.token) {
      navigateLogin();
    }
  }, []);
  const getToken = useCallback(() => {
    return sessionStorage.getItem("refresh")
      ? sessionStorage.getItem("refresh")
      : localStorage.getItem("refresh");
  }, []);
  useEffect(() => {
    async function getNewRefresh() {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/authenticator/ValidateRefreshToken`,
          {
            refresh: getToken(),
          }
        );
        sessionStorage.setItem("refresh", res.data.new_refresh);
        localStorage.setItem("refresh", res.data.new_refresh);
        // // console.log(res.new_refresh, '---');
      } catch (error) { }
    }
    const refresh = setInterval(() => {
      getNewRefresh();
    }, 4.13 * 60000);
    return () => {
      clearInterval(refresh);
    };
  }, [getToken]);
  return (
    <StateContext.Provider
      value={{ isSmall, setIsSmall, isActiveFunc, setIsActiveFunc,collapsed, setCollapsed }}
    >
      <div className={cx("main", "grid")}>
        <Header />
        <div className={cx("container")}>
          <Sidebar />
          <div className={cx("content", isSmall ? "small" : "")}>
            {children}
          </div>
        </div>
      </div>
      <div id="__notification"></div>
    </StateContext.Provider>
  );
};
Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
